import axios from '../utils/axios'

function request(functionId, body) {
  let data = {
    functionId,
    body,
  }
  return axios.request({
    data: data,
    method: 'post'
  })
}

// 分发列表查询
export function queryDistributionList(body) {
  return request("health_cmp_biz_pageDistributionContent", body);
}

// 业务内容列表查询
export function queryBusinessContentList(body) {
  return request("health_cmp_biz_pageOwnAndDistribute", body);
}

// 审核列表查询
export function queryToExamineList(body) {
  return request("health_cmp_biz_pageContentArticle", body);
}

// 单条添加频道接口（覆盖）
export function addChannel(body) {
  return request("health_cmp_biz_updateContentChannel", body);
}

// 批量添加频道（只追加）
export function batchAddChannel(body) {
  return request("health_cmp_biz_batchAppendContentChannel", body);
}

// 查询分发频道楼层
export function queryChannelFloor(body) {
  return request("health_cmp_biz_pageContentChannel", body);
}

// 生成线上文章地址
export function generateOnlineDi(body) {
  return request("health_cmp_biz_generateContentOnlineLink", body);
}

// 获取内容基础信息楼层
export function basicInformationFloor(body) {
  return request("health_cmp_biz_getContentBaseDataFloor", body);
}

// 通过父属性Id查询子属性列表
export function queryChildAttributeByPid(body) {
  return request("health_cmp_biz_queryChildAttributeByPid", body);
}

// export function queryChildAttributeByPid(body) {
//   return request("health_cmp_biz_queryParentAttributeByTyp", body);
// }


// 通过属性类型获取所有父属性
export function queryParentAttributeByTyp(body) {
  return request("health_cmp_biz_queryParentAttributeByTyp", body);
}

// 多选业务查栏目
export function pageCategoriesByBusinessIds(body) {
  return request("health_cmp_pageCategoriesByBusinessIds",body)
}

// 多选栏目查频道
export function pageChannelsByCategoryIds(body) {
  return request("health_cmp_pageChannelsByCategoryIds",body)
}

// 分发文章详情
export function getArticleByPid(body) {
  return request("health_cmp_business_getArticleById",body)
}

// 分发查询活动列表
export function pageQueryActivity(body) {
  return request("cms_marketing_man_pageQueryActivity",body)
}

// 分发查询页面模版
export function queryPageTemplate(body) {
  return request("cms_marketing_man_queryPageTemplate",body)
}
// 添加活动
export function addActivity(body) {
  return request("cms_marketing_man_addActivity", body)
}
// 绑定活动
export function batchBindingContent(body) {
  return request("cms_marketing_man_batchBindingContent", body)
}

// 查询内容质量客观主观和总质量    typeList:  [30] 图文  [31] 视频  [29] 总质量
export function queryDictionaries(body) {
  return request('health_cmp_queryDictionaries', body);
}